import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import AlertModal from "../../../components/alertModal/alertModal";
import CustomBreadcrumb from "../../../components/customBreadcrumb/CustomBreadcrumb";
import CustomRadio from "../../../components/customRadio/CustomRadio";
import MainLoader from "../../../components/loading/MainLoader";
import Title from "../../../components/title/Title";
import {
  addBillComplaint,
  addServiceFault,
  clearErrorFaultNature,
  getTechnicalContactByCctID,
} from "../../../store/actions/fault.action";
import { IRootState } from "../../../store/configureStore";
import BillComplaint, {
  IBillComplainsFormInputs,
} from "./billComplaint/BillComplaint";
import ServiceComplaintSuccessMessage from "./complaintSuccessMessage/ComplaintSuccessMessage";
import ServiceComplaint, {
  IServiceComplainsFormInputs,
} from "./serviceComplaint/ServiceComplaint";
import hasPrivilege from "../../../util/hasPermission";
import PRIVILEGES from "../../../const/privilegesList";

const ReportFault = () => {
  const dispatch: any = useDispatch();

  const { user } = useSelector(({ privileges }: IRootState) => ({
    user: privileges.dataBundleUser,
  }));

  const initialRadioIndex = hasPrivilege(
    user?.role.privileges,
    PRIVILEGES.CREATE_SERVICE_FAULT
  )
    ? 0
    : hasPrivilege(user?.role.privileges, PRIVILEGES.CREATE_BILLING_FAULT)
    ? 1
    : 0;

  const [selectedRadioIndex, setSelectedRadioIndex] =
    useState(initialRadioIndex);

  const [success, setSuccess] = useState("");

  const { technicalContacts, loadingFaultNature, errorFaultNature } =
    useSelector(({ fault }: IRootState) => ({
      technicalContacts: fault.dataTechnicalContactObject,
      loadingFaultNature: fault.loading,
      errorFaultNature: fault.error,
    }));

  const onSubmit = (data: IServiceComplainsFormInputs) => {
    dispatch(addServiceFault(data, setSuccess));
  };

  const onSubmitBill = (data: IBillComplainsFormInputs) => {
    dispatch(addBillComplaint(data, setSuccess));
  };

  const onChangeCCTID = (e: any) => {
    if (e.target.value) {
      const obj = {
        serviceId: e.target.value.trim(),
      };
      dispatch(getTechnicalContactByCctID(obj));
    } else {
      console.log("ss empty");
    }
  };

  const radioItems = [
    ...(hasPrivilege(user?.role.privileges, PRIVILEGES.CREATE_SERVICE_FAULT)
      ? [{ label: "Service Complaint", index: 0 }]
      : []),
    ...(hasPrivilege(user?.role.privileges, PRIVILEGES.CREATE_BILLING_FAULT)
      ? [{ label: "Bill Complaint", index: 1 }]
      : []),
  ];

  return (
    <div className="page-container">
      <MainLoader show={loadingFaultNature} />
      <CustomBreadcrumb
        items={[
          { path: "/", title: "Home" },
          {
            path: "/fault/report",
            title: "Make a Complaint",
          },
        ]}
      />
      {!success && (
        <>
          <Title
            className="text-center font-size-32 mb-4 poppins-semibold"
            color="#1E4894"
          >
            Submit Complaint
          </Title>

          <Row className="justify-content-center mb-5">
            <Col className="col-md-6">
              <CustomRadio
                selectedIndex={selectedRadioIndex}
                onChange={(index: number) => setSelectedRadioIndex(index)}
                items={radioItems}
              />
            </Col>
          </Row>
        </>
      )}
      {!success &&
        (selectedRadioIndex === 0 ? (
          <ServiceComplaint
            onSubmit={onSubmit}
            onChangeCCTID={onChangeCCTID}
            technicalContacts={technicalContacts}
          />
        ) : (
          <BillComplaint onSubmitBill={onSubmitBill} />
        ))}
      {/* error alert */}
      <AlertModal
        show={!!errorFaultNature}
        buttons={[
          {
            variant: "success",
            text: "Close",
            onClick: () => dispatch(clearErrorFaultNature()),
          },
        ]}
        variant="error"
      >
        {errorFaultNature}
      </AlertModal>

      {/* success alert */}
      {success && (
        <ServiceComplaintSuccessMessage
          handleClose={() => setSuccess("")}
          referenceNo={success}
          faultType={selectedRadioIndex === 0 ? "service" : "bill"}
        />
      )}
    </div>
  );
};

export default ReportFault;
